// extracted by mini-css-extract-plugin
export default {"phoneIcon":"NavProfile_phoneIcon__oYrQ7"};